import { useMutation } from '@tanstack/react-query';
import { createScheduleSSR } from '../../queries/WeekSchedule';
import { useParams } from 'react-router-dom';
import { toast } from '../../../../core/components/atoms/Toast';
import { useNavigate } from 'react-router-dom';
import { ISSRPeriod } from '../../model/weekSchedule';

export function useCreateScheduleSSR() {
  const navigate = useNavigate();
  const { UUID: scheduleId } = useParams<{ UUID: string }>();
  const { mutate, isPending, isError } = useMutation({
    mutationKey: ['create-schedule-ssr'],
    mutationFn: (period?: ISSRPeriod) => createScheduleSSR(scheduleId || "", period),
    onSuccess: (data) => {
      if(data.notMinimumQuestion && data.notMinimumQuestion === true) {
        toast({
          title: 'Não foi possível criar o simulado',
          message: 'Não foi possível criar o simulado, pois não há questões suficientes para criar o simulado',
          variant: 'error'
        })

        return;
      }
      
      navigate(`/simulados/simulado/${data.simulatedExamId}`);
    },
    retry: false
  });

  return { mutate, isPending, isError };
}
